import {RadioField} from '@/components/commons/radio-field/RadioField'
import styled, {css} from 'styled-components'

export const StyledPrintSiarCategoryRadioField = styled(RadioField)(
    ({theme: {typography, palette, spacing}}) => css`
        & > label {
            align-items: center;
        }

        & > label p {
            ${typography.textMd};
            color: ${palette.neutral[950]};
            font-weight: 500;
        }

        & > input[type='radio'] {
            width: 14px;
            height: 14px;
            padding: ${spacing}px;
        }
    `
)
